import { render, staticRenderFns } from "./AboutLetuopin.vue?vue&type=template&id=2ea22bab&scoped=true&"
import script from "./AboutLetuopin.vue?vue&type=script&lang=js&"
export * from "./AboutLetuopin.vue?vue&type=script&lang=js&"
import style0 from "./AboutLetuopin.vue?vue&type=style&index=0&id=2ea22bab&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ea22bab",
  null
  
)

export default component.exports